import { type Client, clientSingleton } from '@edge/spark/io-apollo'
import { useIsGlobalAdminQuery, IsGlobalAdminDocument, type IsGlobalAdminQuery } from '../generated/graphql'

/** React hook to check if user is a Global/AuctionEdge admin */
export const useIsGlobalAdmin = (...props: Parameters<typeof useIsGlobalAdminQuery>): boolean => {
    const { data } = useIsGlobalAdminQuery(...props)

    return data?.user?.attributes?.isGlobalAdmin || false
}

interface GetIsGlobalAdminProps {
    /** ApolloClient. Attempts to use client singleton if not passed */
    client?: Client
}

/** Check if user is a Global/AuctionEdge admin */
export const getIsGlobalAdmin = async (props?: GetIsGlobalAdminProps) => {
    const client = props?.client || clientSingleton
    const { data } = await client.query<IsGlobalAdminQuery>({
        query: IsGlobalAdminDocument,
        fetchPolicy: 'network-only',
    }) // useIsGlobalAdminQuery()
    return data?.user?.attributes?.isGlobalAdmin || false
}

/** @deprecated Alias for `useIsGlobalAdmin`. React hook to check if user is a Global/AuctionEdge admin */
export const useIsEdgeAdmin = useIsGlobalAdmin

/** @deprecated Use `useIsGlobalAdmin` instead */
export const useGlobalAdminCheck = useIsGlobalAdmin
